import en from "../../translations/en.json";
import de from "../../translations/de.json";

import { createUseI18n } from "keycloakify/login";

export const { useI18n } = createUseI18n({
  en,
  de,
});

export type I18n = NonNullable<ReturnType<typeof useI18n>>;
